.default-phone {
  width: 100%;
  display: flex;
  gap: 8px;
}

.default-phone > .default-phone-number {
  max-width: 60%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.default-phone > .additional-phone-indicator {
  width: 40%;
  cursor: pointer;
}

.additional-phone {
  position: absolute;
  display: none;
  width: 300px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  background-color: #FFFFF0;
  border-style: solid;
  border-width: 1px;
  border-color: rgba(250, 235, 215, 1);
  border-radius: 4px;
  z-index: 1;
}

.additional-phone.expanded {
  display: block;
}
